import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';
import React, { CSSProperties } from 'react';

import Portal from '@mui/material/Portal';
import Snackbar from '@mui/material/Snackbar';

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

interface AlertSnackbarProps {
  open: boolean;
  message: string;
  severity: AlertColor;
  autoHideDuration?: number;
  hideIcon?: boolean;
  isAutoHide?: boolean;
  style?: CSSProperties;
  onClose: () => void;
}

const AlertSnackbar = (props: AlertSnackbarProps) => {
  const autoHide = props.isAutoHide ? null : props.autoHideDuration || 6000;
  return (
    <Portal>
      <Snackbar
        open={props.open}
        autoHideDuration={autoHide}
        onClose={props.onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <div>
          <Alert
            onClose={props.onClose}
            severity={props.severity}
            icon={!props.hideIcon}
            style={props.style}
          >
            {props.message}
          </Alert>
        </div>
      </Snackbar>
    </Portal>
  );
};

export default AlertSnackbar;
